module.exports = __webpack_public_path__ + "img/img_main_con2.a2d0b481.jpg";